<template>
  <Card noBorder>
    <SectionHeader title="Features You're Trying">
      Try features outside of your package for free.
    </SectionHeader>
    <FormWrapper>
      <TrialFeatureCard
        v-for="trialFeature in trialFeatureList"
        :key="trialFeature.featureKey"
        :featureCode="trialFeature.featureCode"
        :featureDescription="trialFeature.featureDescription"
        :featureTitle="trialFeature.featureTitle"
      />
    </FormWrapper>
  </Card>
</template>

<script>
import { Card } from '@jumpcloud/ui-components';
import { FeatureTrialTextConsts, trialPropsData } from 'client/util/Constants/FeatureTrialConstants';
import FeatureTrialsMixin from 'client/GrowthEngineering/utilities/FeatureTrialsMixin';
import FormWrapper from 'client/components/Forms/FormWrapper.vue';
import SectionHeader from 'client/settings/components/SectionHeader.vue';
import TrialFeatureCard from './TrialFeatureCard.vue';

export default {
  name: 'SectionFeaturesTrial',

  components: {
    Card,
    FormWrapper,
    SectionHeader,
    TrialFeatureCard,
  },

  mixins: [
    FeatureTrialsMixin,
  ],

  props: {
    trialFeatures: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    trialFeatureList() {
      return Object.keys(this.trialFeatures).map(featureKey => ({
        ...FeatureTrialTextConsts[featureKey],
        featureKey,
        modalProps: trialPropsData[featureKey],
        trialStart: this.getTrialStartDate(featureKey),
      }));
    },
  },
};
</script>
